export const NOTIFICATION_ICON = require('./Images/Notification.png');
export const NOMESSAGE_ICON = require('./Images/noMessage.png');
export const CHECK = require('./Images/check.png');
export const ADD = require('./Images/add.png');
export const MINUS = require('./Images/minus.png');
export const CHEVRON_RIGHT = require('./Images/chevron-right.png');
export const ARROW_RIGHT = require('./Images/right-arrow.png');

// Overlay Tip Images
export const DIRECTIVE_ARROW_1 = require('./Images/directive-arrow-1.png');
export const DIRECTIVE_ARROW_2 = require('./Images/directive-arrow-2.png');
export const DIRECTIVE_ARROW_3 = require('./Images/directive-arrow-3.png');

//checkInGuideImages
export const VERIFY_DETAILS = require('./checkInGuideImages/verifyDetails.png');
export const VERIFY_ID = require('./checkInGuideImages/img_verifyID.png');
export const BOOKING_DETAILS = require('./checkInGuideImages/img_bookingDetails.png');
export const CARD = require('./checkInGuideImages/img_card.png');

export const CUSTOM_LOADER = require('./Images/loader.png');

export let CUSTOM_LOADER_LOTTIE = null;
// try {
//     CUSTOM_LOADER_LOTTIE = require('./custom_loader.json');
// } catch {}


export let CUSTOM_PRELOADER_IMG = null;
try {
    CUSTOM_PRELOADER_IMG = require('./custom_preloader.jpg');
} catch {}

export let CUSTOM_PRELOADER_VIDEO = null;
// try {
//     CUSTOM_PRELOADER_VIDEO = require('./custom_preloader_video.mp4');
// } catch {}

export let CUSTOM_PRELOADER_LOADER = null;
// try {
//     CUSTOM_PRELOADER_LOADER = require('./CUSTOM_PRELOADER_LOADER.json');
// } catch {}


// Door key images 
export const DOOR_UNLOCK = require('./doorKeyGuideImages/door_unlock.png');
export const KEY_HELP = require('./doorKeyGuideImages/key_help.png');
export const KEY_HELP_PERMISSION = require('./doorKeyGuideImages/key_helpPermission.png');

export const EXTERNAL_LINK = require('./Images/externalLink.png');
export const CHEVRON_LEFT = require('./Images/chevron-left.png');
export const CHEVRON_DOWN = require('./Images/chevron-down.png');
export const CHEVRON_UP = require('./Images/chevron-up.png');
export const PLUS = require('./Images/plus.png');
export const INFO_CIRCLE = require('./Images/info-circle.png');
export const CROSS = require('./Images/cross.png');
export const RIGHT_CHECK = require('./Images/RightCheck.png');
export const ERROR_500 = require('./Images/error_500.png');
export const CROSS_ERROR = require('./Images/cross_error.png');

export const APPLE_WALLET_BUTTON = require('./Images/apple-wallet-logo.png');

export const SUCCESS_CHECK = require('./Images/success-check.png');

export const KEY_ICON = require('./Images/ico_generic_doorkey.png');

export const FRONT_ICON = require('./Images/front-icon.png');
export const LEFT_ICON = require('./Images/left-icon.png');
export const RIGHT_ICON = require('./Images/right-icon.png');
